export default __webpack_public_path__ + "static/media/Dedicated.74113a4c.svg";